//
import { mapActions } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import Translator from '@/services/translator'

//
import UserModel from '@/models/General/GUser'
import fields from './fields'

//
export default {
    name: 'user-create',
    components: {
        'model-form': ModelForm,
    },
    computed: {

        /**
         * @description
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        fieldsProps() {
            return {
                g_branch_office_trigger: this.triggerBranch,
            }
        },

        /**
         * @description
         * { function_description }
         *
         * @return     {Object}  { description_of_the_return_value }
         */
        formProps () {
            return {
                fields: fields(this.fieldsProps),
            }
        },
    },
    data () {
        return {
            formData: {},
        }
    },
    methods: {

        //
        ...mapActions( 'MenuesModule', {
            setAppToolbarTitle: 'setAppToolbarTitle',
        }),

        /**
         * 
         */
        create(model) {
            model.toCreate().save().then( this.success ).then( this.redirect ).catch( this.error ).then( this.$refs.form.setWait )
        },

        /**
         * Fetches a suggest auth code.
         *
         * @return     {<type>}  The suggest auth code.
         */
        fetchSuggestAuthCode() {
            return this.formData.fetchSuggestAuthCode()
        },

        /**
         * Fetches a suggest bar auth code.
         *
         * @return     {<type>}  The suggest bar auth code.
         */
        fetchSuggestBarAuthCode() {
            return this.formData.fetchSuggestBarAuthCode()
        },

        /**
         * 
         */
        error(error){
            this.$toast.error( Translator( UserModel, error.response.data ) )
        },

        /**
         * 
         */
        redirect() {
            this.$router.push({ name: 'user-list' })
        },

        /**
         * 
         */
        reset() {
            this.formData = new UserModel({
                g_selected_branch_offices: []
            })
        },

        /**
         * 
         */
        submit () {
            this.$refs.form.setWait(true).then(this.create)
        },

        /**
         * @description
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitSuggestAuthCode() {
            return this
                .toWait(true)
                .then(this.fetchSuggestAuthCode)
                .then(this.toWait)
        },

        /**
         * { function_description }
         *
         * @return     {<type>}  { description_of_the_return_value }
         */
        submitSuggestBarAuthCode() {
            return this
                .toWait(true)
                .then(this.fetchSuggestBarAuthCode)
                .then(this.toWait)
        },

        /**
         * 
         */
        success () {
            this.$toast.success('Usuario agregado.')
        },

        /**
         * @description
         * { function_description }
         *
         * @param      {boolean}  [value=false]  The value
         * @return     {<type>}   { description_of_the_return_value }
         */
        toWait(value = false) {
            return this.$refs.form.setWait(value)
        },

        /**
         * @description
         * { function_description }
         *
         * @param      {<type>}  ctx     The context
         */
        triggerBranch(ctx) {

            //
            const branch = ctx.getInput('g_branch_office_id').getSelected()
            const select = this.formData.g_selected_branch_offices.find(item => item.id === branch.id)

            //
            if (branch.id && !select) {
                this.formData.g_selected_branch_offices.push(branch)
            }
        },
    },
    beforeMount () {
        this.setAppToolbarTitle({ title: 'Crear usuario' })
    },
    mounted () {
        this.reset()
    }
}